// Welcome interface JavaScript entry point (public pages)
import { createApp } from 'vue'

// Import welcome-specific files
import '../welcome/welcome.js'
import '../welcome/welcome-tabs.js'

// Import welcome-specific components as needed
// Example: import WelcomePage from '@components/welcome/WelcomePage.vue'

// Global Vue app instance for mounting welcome components
window.mountWelcomeComponent = function(componentName, element, props = {}) {
  const components = {
    // Add your welcome components here
  }

  const component = components[componentName]
  if (component) {
    const app = createApp(component, props)
    app.mount(element)
    return app
  } else {
    console.error(`Welcome component '${componentName}' not found`)
  }
}

// Import application-init LAST — must execute after all role code is on window
import './application-init.js'

// Auto-mount components on page load
document.addEventListener('DOMContentLoaded', () => {
  console.log('Welcome interface loaded')

  document.querySelectorAll('[data-vue-component]').forEach(el => {
    const componentName = el.dataset.vueComponent
    const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}
    window.mountWelcomeComponent(componentName, el, props)
  })
})
